module.exports = __webpack_public_path__ + "media/images/icon-info-d4c62431edab158864bf4a0b41085545.svg";